const Colors = [
    {
        0: '#F9D9EB',
        1: '#3040C4'
    },
    {
        0: '#FFE3DE',
        1: '#593599'
    },
    {
        0: '#F1A4A1',
        1: '#323232'
    },
    {
        0: '#CCE7B0',
        1: '#254569'
    },
    {
        0: '#A6B1E1',
        1: '#424874'
    },
    {
        0: '#E5E4CC',
        1: '#698474'
    },
    {
        0: '#F6E7E6',
        1: '#7D8DA9'
    },
    {
        0: '#E4F2F0',
        1: '#93A8AC'
    },
    {
        0: '#D9F3FF',
        1: '#45969B'
    },
    {
        0: '#FED8CB',
        1: '#E1836A'
    }
]

export default Colors;